// The reporting scope shared by the IPEDS DCS extracts (Awards & Completions, 12-Month
// Enrollment): a reporting year, one of the two bulk-upload formats, and the July 1 – June 30
// period the year brings with it. Display and validation only.
import { getReportingYear } from './reportingYears';

// Fixed Length is the only bulk-upload format the wizard offers for the DCS extracts.
export const DCS_OUTPUT_FORMATS = [
    { code: 'FIXED', labelKey: 'ipedsWizard.formatFixedLength' }
];

/** A reporting year always brings its standard July 1 – June 30 period with it. */
export const reportingPeriodFor = (reportingYearId) => {
    const year = getReportingYear(reportingYearId);
    return year ? { reportingPeriodStart: year.periodStart, reportingPeriodEnd: year.periodEnd } : {};
};

// DateInput stores "YYYY-MM-DDTHH:mm:ss" and writes "Invalid date" for a half-typed value.
const datePart = (value) => (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value) ? value.slice(0, 10) : null);

/**
 * Field → { key, field } for every rule the reporting scope breaks. `field` is the i18n key of
 * the label the message names, so "{Field} Required" reads e.g. "Start Date Required". Each
 * extract captions its period pickers in its own words, so it passes those labels in.
 */
export const getReportingScopeErrors = (parameters, { startLabel, endLabel, endBeforeStartKey }) => {
    const errors = {};
    const required = (name, labelKey) => { errors[name] = { key: 'ipedsWizard.fieldRequired', field: labelKey }; };

    if (!parameters.reportingYear) required('reportingYear', 'ipedsWizard.reportingYear');
    if (!parameters.outputFormat) required('outputFormat', 'ipedsWizard.outputFormat');

    const dates = [
        ['reportingPeriodStart', startLabel],
        ['reportingPeriodEnd', endLabel]
    ];
    dates.forEach(([name, labelKey]) => {
        if (!parameters[name]) required(name, labelKey);
        else if (!datePart(parameters[name])) errors[name] = { key: 'ipedsWizard.invalidDate', field: labelKey };
    });

    const start = datePart(parameters.reportingPeriodStart);
    const end = datePart(parameters.reportingPeriodEnd);
    if (start && end && end < start) {
        errors.reportingPeriodEnd = { key: endBeforeStartKey, field: endLabel };
    }

    return errors;
};
